import React from 'react';

export default ({ width = 32, height = 32, fill = '#FFFFFA' }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 512 512'
			preserveAspectRatio='xMidYMid meet'
		>
			<g
				fill={fill}
				stroke={'none'}
				transform={'translate(0,512) scale(0.100000,-0.100000)'}
			>
				<path d='M2244 4000 c-1129 -94 -2027 -964 -2154 -2087 -7 -56 -10 -162 -8 -235 3 -127 5 -137 35 -199 62 -126 186 -218 323 -240 197 -31 397 89 465 281 10 26 20 105 25 190 11 173 30 279 76 420 196 610 765 1020 1414 1020 408 0 752 -143 1047 -434 126 -126 149 -159 134 -200 -11 -28 -43 -41 -221 -92 -117 -33 -141 -43 -177 -77 -105 -97 -89 -257 34 -335 26 -17 380 -224 785 -460 487 -284 749 -431 775 -435 65 -11 146 17 189 65 58 63 55 6 52 1005 l-3 918 -28 47 c-49 84 -150 124 -246 98 -34 -9 -66 -33 -140 -104 -158 -151 -177 -166 -214 -166 -38 0 -51 12 -169 160 -367 458 -910 763 -1503 845 -132 18 -366 26 -491 15z' />
			</g>
		</svg>
	);
};
